module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"service_table.field.jobs_detail":"งานที่ต้องทำ :","service_table.field.jobs_detail.unspecify":"ไม่ระบุงาน","service_table.field.open_type":"รับงานจาก :","service_table.field.return_type":"ส่งคืน :","service_table.field.return_type.refer":"ส่งต่อ :"}}')
  delete Component.options._Ctor
}
